module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: [
      'header',
      {
        'header--hidden': _vm.appPage.meta.noFooter,
        'header--scrolled': _vm.appScrollY > 0,
      } ]
  }, [_c('span', {
    staticClass: "header__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('module-logo', {
    staticClass: "header__logo",
    attrs: {
      "link": "home"
    }
  }), _vm._v(" "), _c('ui-navigation')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a1fa04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Header.vue
// module id = 31
// module chunks = 1